import React from 'react';
import BackgroundTasks from '../../components/background-tasks/BackgroundTasks';

const BackgroundTask: React.FC = () => {
  return <BackgroundTasks />;
};

export default BackgroundTask;
